export default "__VITE_ASSET__CgkWaUTc__"